module.exports = __webpack_public_path__ + "static/media/usb-a-gold.d96956b7.svg";